import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import { observer, inject } from 'mobx-react';
import { useEffect, useRef } from 'react';
import CloseOneIcon from '../svg/CloseOneIcon';
import Search from './Search';

const MobileSearch = inject('studioStore')(observer(({ studioStore, isOpen, onClose }) => {
  const primaryColor = studioStore?.settings?.colors?.primary_color;
  const searchRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            ref={searchRef}
            initial={{ y: '-100%', opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: '-100%', opacity: 0 }}
            transition={{ type: 'tween', duration: 0.3 }}
            className="absolute left-0 right-0 -bottom-[90%] bg-white z-50 shadow-lg"
          >
            <div className="flex items-center bg-primary-light-studio p-4 px-2">
              <div className="flex-1">
                <Search onClose={onClose} />
              </div>
              <button
                onClick={onClose}
                className="ms-2 py-2 px-1 rounded-md hover:bg-gray-100"
                aria-label="Close search"
              >
                <CloseOneIcon stroke={primaryColor} />
              </button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}));

MobileSearch.propTypes = {
  studioStore: PropTypes.shape({
    settings: PropTypes.shape({
      colors: PropTypes.shape({
        primary_color: PropTypes.string,
      }),
    }),
  }),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default MobileSearch;